/**
 * Project : workspace
 * File    : SelfBusinessSelectScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.self_business.select

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel
import com.parmartechnologies.core.navigation.NavigationParam
import com.parmartechnologies.storage.constant.KeyConstant
import com.parmartechnologies.storage.store.UserDefaults
import component.empty.EmptyData
import component.loader.AppLoader
import component.navigation.TopNavBar
import kotlinx.serialization.json.Json
import locale.localization
import navigation.AppNavigator
import navigation.route.business.BusinessNavRoute
import presentation.screens.business.self_business.component.SelfBusinessSelectCard
import theme.ThemeColor

/**
 * Represents the self business select screen class.
 */

class SelfBusinessSelectScreen{
    @Composable
    fun Content() {
        val viewModel = BusinessViewModel()
        val allBusiness = viewModel.allBusiness.collectAsState()
        LaunchedEffect(key1 = Unit) {
            viewModel.loadBusiness()
        }
        Column(modifier = Modifier.fillMaxSize().background(ThemeColor.shared().defaultBakground)) {
            TopNavBar(title = localization().businessList.title, NavigationParam(), onBackPress = {
                AppNavigator.shared().goBack()
            }, onClickAdd = {
                AppNavigator.shared().navigate(BusinessNavRoute.BUSINESS_TYPE)
            })
            AppLoader(viewModel)
            if (allBusiness.value.isNotEmpty()) {
                LazyVerticalGrid(
                    columns = GridCells.Adaptive(minSize = 400.dp),
                    modifier = Modifier.fillMaxSize().padding(bottom = 60.dp)
                ) {
                    items(allBusiness.value.count()) { index ->
                        SelfBusinessSelectCard(allBusiness.value[index]) {
                            viewModel.setMyBusiness(it)
                             val decoder = Json {
                                encodeDefaults = true
                                ignoreUnknownKeys = true
                                isLenient = true
                            }
                            UserDefaults.shared().store(KeyConstant.myBusiness, decoder.encodeToString(it))
                            AppNavigator.shared().goBack()
                        }
                    }
                }
            } else {
                EmptyData(viewModel = viewModel) {
                    viewModel.loadBusiness()
                }
            }
        }
    }
}